export const confirmDialogTypeArr = ['success', 'danger', 'warning'] as const;
export type ConfirmDialogType = typeof confirmDialogTypeArr[number];
export interface ConfirmDialogData {
  width?: string;
  type?: ConfirmDialogType;
  title?: string;
  description?: string;
  confirmLabel?: string | {
    text: string;
    link?: string;
  };
  dismissLabel?: string;
  hideDismissButton?: boolean;
  isOnlyView?: boolean;
  titleClass?: string;
  descriptionHtml?: boolean;
}
